// Unpublished Work © 2021-2026 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import WorkBoardDialogContent from 'OnLabor/my-work/work-board-dialog/work-board-dialog-content';
import {connect} from 'react-redux';
import accounting from 'accounting';
import WorkBoardJobDetails from 'OnLabor/my-work/work-board-dialog/work-board-dialog-jobs/work-board-job-details';
import {TRUE} from 'Ui/constants/membership-properties';
import {getOperatorFormattedName} from 'OnLabor/workboard/utils/operator-utils';

const ONE_HOUR = 60.0;

function getJobDetails(workboard, translations, properties, operators) {
    const {jobs} = workboard;
    const showEstimatedHours = properties.workboard_presentation_show_estimated_hours === TRUE;

    const workItems = jobs.flatMap((job) => {
        const {
            jobTemplate,
            title,
            workItems
        } = job;

        return workItems.map((workItem) => {
            const {
                appUserId,
                estDuration,
                equipment,
                note,
                route,
                routeCustomDefn,
                workItemId
            } = workItem;

            const operator = operators.find((operator) => operator.id === appUserId);

            return {
                appUserId,
                estHours: showEstimatedHours ? accounting.formatNumber(estDuration / ONE_HOUR, 1) : null,
                equipment,
                jobTemplateId: jobTemplate?.jobTemplateId,
                note,
                route,
                routeCustomDefn,
                secondaryName: jobTemplate?.secondaryName,
                title,
                user: operator ? getOperatorFormattedName(operator) : translations.ONLINK_USER_NOT_AVAILABLE,
                workItemId
            };
        });
    });

    if (workItems.length === 0) {
        return (
            <div className='empty-workboard-message'>
                {translations.ONLINK_NO_WORK_ASSIGNED}
            </div>
        );
    }

    return (
        <WorkBoardJobDetails
            properties={properties}
            translations={translations}
            workItems={workItems}
            workboard={workboard}
        />
    );
}

function WorkBoardDialogJobs(props) {
    const {
        translations,
        properties,
        workboard,
        operators
    } = props;

    return (
        <WorkBoardDialogContent
            loading={false}
            translations={translations}
            workboard={workboard}
        >
            <div className={'job-card-flex'}>
                {workboard && getJobDetails(workboard, translations, properties, operators)}
            </div>
        </WorkBoardDialogContent>
    );
}

WorkBoardDialogJobs.propTypes = {
    operators: PropTypes.array,
    properties: PropTypes.object,
    translations: PropTypes.translations,
    workboard: PropTypes.object
};

export function mapStateToProps(state) {
    return {
        properties: state.membership.properties
    };
}

export default connect(mapStateToProps)(WorkBoardDialogJobs);
